<template>
  <div class="content">
    <div class="loading-overlay" :class="show ? 'is-active' : ''">
      <span class="fas fa-spinner fa-3x fa-spin"></span>
    </div>
    <div v-if="rendered" class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div
            class="d-flex flex-column align-items-stretch flex-shrink-0 bg-white"
          >
            <a
              href="/"
              class="marineBg d-flex align-items-center flex-shrink-0 p-3 link-dark text-decoration-none border-bottom"
            >
              <h2 class="mt-0 mb-0">Alertas</h2>
            </a>
            <div
              class="mt-3 alertas list-group list-group-flush border-bottom scrollarea"
            >
              <div
                class="list-group-item list-group-item-action py-3 lh-tight"
                aria-current="true"
                v-for="(msg, i) in alertas"
                :key="i"
              >
                <div class="d-flex w-100 align-items-center">
                  <p class="mb-1">{{ msg.dt_created }}</p>
                </div>
                <div class="d-flex w-100 align-items-center">
                  <h3>{{ msg.mensagem }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="utilizador.nivel == 1">
        <div class="col-lg-12">
          <div class="card" style="border: 1px solid #d9d9d9 !important;">
            <textarea
              id="enviarAlerta"
              class="form-control mt-3 p-3"
              placeholder="Alerta"
              type="text"
              v-model="mensagem"
              v-on:keyup.enter="submeter()"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="notificacao"
      footerClasses="justify-content-center "
      type="notice"
      persistent
    >
      <div class="instruction">
        <div class="row mt-3">
          <div class="col-md-12 text-center">
            <div class="form-group text-left">
              <h2>{{ mensagem }}</h2>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="justify-content-center">
        <base-button type="success" simple @click="notificacao = false"
          >Percebi</base-button
        >
      </div>
    </modal>
  </div>
</template>

<script>
  import Pusher from "pusher-js";
  import { ImageUpload, Modal } from "@/components/index";
  import api from "@/api/index";
  export default {
    components: {
      ImageUpload,
      Modal,
    },
    data() {
      return {
        descricao: "",
        notificacao: false,
        ficheiroCarregado: [],
        rendered: false,
        show: true,
        ficheiro: false,
        galleryTitle: "Vue Gallery Component",
        showNav: 1,
        keyBoardNav: 1,
        showcaption: 1,
        loop: 1,
        images: [],
        allowKeyboard: 1,
        imageIndex: 0,
        active: 0,
        utilizador: [],
        mensagem: "",
        alertas: [],
        modalUpload: false,
      };
    },
    methods: {
      async submeter() {
        var _this = this;
        let envioJson = {
          user_id: this.utilizador.user_id,
          username: this.utilizador.nome,
          mensagem: this.mensagem,
        };
        let envio = await api.registarAlertas(envioJson);

        if (envio.resultado == "OK") {
          var formdata = new FormData();
          formdata.append("username", _this.utilizador.nome);
          formdata.append("mensagem", _this.mensagem);

          var requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
          };

          await fetch(
            "https://yourcode-staging.com/niu-mensagens/index_alertas.php",
            requestOptions
          );
          _this.mensagem = "";
        }
      },
    },
    async mounted() {
      var currentdate = new Date();
      var mes = currentdate.getMonth() + 1;
      var dia = currentdate.getDate();
      var horas = currentdate.getHours();
      var minutos = currentdate.getMinutes();
      var segundos = currentdate.getSeconds();
      if (dia.toString().length == 1) {
        dia = "0" + dia.toString();
      }
      if (mes.toString().length == 1) {
        mes = "0" + mes.toString();
      }
      if (horas.toString().length == 1) {
        horas = "0" + horas.toString();
      }
      if (minutos.toString().length == 1) {
        minutos = "0" + minutos.toString();
      }
      if (segundos.toString().length == 1) {
        segundos = "0" + segundos.toString();
      }
      var datetime =
        currentdate.getFullYear() +
        "-" +
        mes +
        "-" +
        dia +
        " " +
        horas +
        ":" +
        minutos +
        ":" +
        segundos;
      var _this = this;
      Pusher.logToConsole = false;

      const pusher = new Pusher("0301792fa0059f29eefc", {
        cluster: "eu",
      });

      const channel = pusher.subscribe("alertas");
      channel.bind("alerta", async (data) => {
        data.dt_created = datetime;
        _this.alertas.splice(0, 0, data);
        _this.mensagem = data.mensagem;
        if (_this.utilizador.nivel != 1) {
          _this.notificacao = true;
        }
      });

      var user_id = localStorage.getItem("active-session-niu");
      var jsonUser = {
        user_id: user_id,
      };

      let res = await api.buscarDados(jsonUser);
      if (Object.values(res).length > 0) {
        this.utilizador = Object.values(res)[0];
      }

      //BUSCAR ALERTAS
      let resMensagens = await api.buscarAlertas();
      resMensagens = Object.values(resMensagens).sort(function(a, b) {
        return Number(a.id) > Number(b.id) ? -1 : 1;
      });
      this.alertas = resMensagens;
      this.rendered = true;
      this.show = false;
    },
  };
</script>
<style lang="scss">
  #enviarAlerta::placeholder {
    color: #ccc !important;
    font-size: 14px;
  }
  .scrollarea {
    max-height: 60vh;
    overflow: auto;
  }

  .alertas .list-group-item {
    border: 2px solid #6d32ff;
    margin-bottom: 15px;
    background: #6d32ff;
  }

  .alertas .list-group-item p,
  .alertas .list-group-item h3 {
    color: #fff !important;
  }
</style>
